import clsx from "clsx";

function PulseDot({ isOutDated }) {

    return (
        <>
            <div className={clsx("container", {
                success: !isOutDated,
                danger: isOutDated
            })}>
                <div className="ringring"></div>
                <div className="circle"></div>
            </div>
            <style jsx global>{`
              .ring-container {
                position: relative;
              }
              
              .success .ringring, .success .circle {
                background-color: #62bd19;
                border: 3px solid #62bd19;
              }
              
              .danger .ringring, .danger .circle {
                background-color: rgb(237, 28, 36);
                border: 3px solid rgb(237, 28, 36);
              }

              .circle {
                width: 12px;
                height: 12px;
                border-radius: 50%;
                position: absolute;
                top: 0px;
                left: 0px;
              }

              .ringring {
                border: 3px solid white;
                -webkit-border-radius: 30px;
                height: 20px;
                width: 20px;
                position: absolute;
                left: -4px;
                top: -4px;
                -webkit-animation: pulsate 1s ease-out;
                -webkit-animation-iteration-count: infinite;
                opacity: 0.0
              }

              @-webkit-keyframes pulsate {
                0% {
                  -webkit-transform: scale(0.1, 0.1);
                  opacity: 0.0;
                }
                50% {
                  opacity: 1.0;
                }
                100% {
                  -webkit-transform: scale(1.2, 1.2);
                  opacity: 0.0;
                }
              }
            `}</style>
        </>
    )
}


export default PulseDot